import { ICategoryInfo } from '../category';

export const getDealType = ({ dealType, rentDuration }: ICategoryInfo) => {
  if (dealType === 'rent' && rentDuration === 'short') {
    return 'daily_rent';
  }

  return dealType;
};
